import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { errorLogger } from "@/Common/helpers/logger";
import { IUserToCreate } from "@/DataPages/types/users/users";
import { apiInstance, gql } from "@/services/httpAdapter";

interface ICreateUserInput {
	activeUsers: IUserToCreate[];
	inactiveUsers: IUserToCreate[];
}

interface ICreateUsersRespone {
	locationId: string;
	activeUsersPositions: string[];
	inactiveUsersPositions: string[];
	unenrolledEmployeesPositions: string[];
}

export async function sendUsers(locationId: string, users: ICreateUserInput) {
	const query = gql`
		mutation convertEmployeesToUsers($locationId: String!, $input: InUsers) {
			convertEmployeesToUsers(locationId: $locationId, input: $input) {
				locationId
				activeUsersPositions
				inactiveUsersPositions
				unenrolledEmployeesPositions
			}
		}
	`;

	const variables = {
		locationId,
		input: users,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		const responseData: GraphqlQueryResponse<"convertEmployeesToUsers", ICreateUsersRespone> = response.data;
		return responseData.data.data?.convertEmployeesToUsers;
	} catch (err) {
		errorLogger(err as Error);
		return null;
	}
}
